import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { SimpleSVG } from 'vue3-simple-svg'

import './assets/styles/_main.scss'

import { createPinia } from 'pinia'
import DefaultButton from './components/ui/DefaultButton.vue'
import ImageButton from './components/ui/ImageButton.vue'
import VInput from './components/ui/VInput.vue'
import VDropdown from './components/ui/VDropdown.vue'

createApp(App)
    .component('v-dropdown', VDropdown)
    .component('v-input', VInput)
    .component('image-button', ImageButton)
    .component('default-button', DefaultButton)
    .component('simple-svg', SimpleSVG)
    .use(createPinia())
    .use(router)
    .mount('#app')
